export default __webpack_public_path__ + "static/media/testimonial-img-12.16063565.jpg";